import { IRowData } from '@components/simple-table/types';
import { useTranslation } from 'react-i18next';
import { Box } from '@mantine/core';
import OverflowTip from '@components/OverflowTip';
import { ActionValue } from '@/entities/admin-app/statistics';

const useGetValue = (value: ActionValue): string => {
  const { t } = useTranslation();

  if (!value || Object.keys(value).length === 0) {
    return t('noData');
  }

  const values = (Object.keys(value) as (keyof ActionValue)[]).map((key): string | false => {
    const data = value[key];

    if (!Array.isArray(data)) {
      return false;
    }

    const v = data.filter(Boolean);

    if (v.length > 0) {
      return `${t(`statistics.valuesActions.${key}`)}: ${v.join(', ')}`;
    }

    return false;
  });

  if (values.length === 0) {
    return t('noData');
  }

  return values.filter(Boolean).join(', ');
};

export const OldValuesCell = (props: IRowData) => {
  const { OldValues, OldValue } = props;
  const vs = useGetValue(OldValues);

  const values = OldValue ? OldValue : vs;

  return (
    <Box maw={300}>
      <OverflowTip component="p">{values || '-'}</OverflowTip>
    </Box>
  );
};

export const NewValuesCell = (props: IRowData) => {
  const { NewValues, NewValue } = props;
  const vs = useGetValue(NewValues);

  const values = NewValue ? NewValue : vs;

  return (
    <Box maw={300}>
      <OverflowTip component="p">{values || '-'}</OverflowTip>
    </Box>
  );
};
